<template>
  <div class="content-container work-container" :class="viewMode">
    <article class="work detail-content">
      <div class="fixed-container">
        <div class="inner">
          <div class="icon-cancel" title="Close" @click="hideFull()"></div>
        </div>
      </div>
      <div class="edit-bar" v-if="isAdmin"><div class="edit" v-on:click.stop="editNode(fullNode.nid)">Edit</div></div>
      <div v-if="fullNode.hasImages" class="pictures" :class="fullNode.imageClasses">
        <figure v-for="(img,index) in fullNode.images" v-if="img.show">
          <template v-if="img.picture">
            <vue-picture :imgset="img" :sizes="fullSizes" :className="img.attributes.className"></vue-picture>
          </template>
          <template v-else>
            <picture class="original" :class="img.attributes.className">
              <img :src="img.sizes.orig" :alt="img.attributes.title" :width="img.attributes.width" :height="img.attributes.height" />
            </picture>
          </template>
          <figcaption>{{img.attributes.alt}}</figcaption>
        </figure>
       </div>
       <h2 class="article-title">{{fullNode.title}}</h2>
        <div class="info">
          <time class="date">{{fullNode.date}}</time>
          <h5 class="category">{{fullNode.category}}</h5>
        </div>
       <div class="body" v-html="fullNode.body"></div>
      <template v-for="(section,index) in fullNode.sections">
        <div class="section" :class="'section-'+ index">
          <template v-if="section.has_media">
            <div class="media" :class="section.media.type">
              <template v-if="section.media.type == 'embed'">
                <vue-embedplayer :media="section.media" :current="mediaPlaying"></vue-embedplayer>
              </template>
              <template v-if="section.media.type == 'video'">
                <vue-videoplayer :media="section.media" :current="mediaPlaying"></vue-videoplayer>
              </template>
              <template v-if="section.media.type == 'audio'">
                <vue-audioplayer :media="section.media" :current="mediaPlaying"></vue-audioplayer>
              </template>
            </div>
          </template>
          <template v-if="section.hasImages">
            <div class="pictures" :class="section.imageClasses">
             <template v-for="(img,imgIndex) in section.images">
                <figure :key="imgIndex">
                  <template v-if="img.picture">
                    <vue-picture :imgset="img" :sizes="fullSizes" :className="img.attributes.className"></vue-picture>
                  </template>
                  <template v-else>
                    <picture class="original" :class="img.attributes.className">
                      <img :src="img.sizes.orig" :alt="img.attributes.title" :width="img.attributes.width" :height="img.attributes.height" />
                    </picture>
                  </template>
                  <figcaption>{{img.attributes.alt}}</figcaption>
                </figure>
              </template>
            </div>
          </template>
          <div class="text" v-html="section.text"></div>
        </div>
      </template>
    </article>
    <div class="work main-content" :data-scroll="prevY" :class="{'images-loaded':imgsLoaded}">
      <h2 class="content-title">{{title}}</h2>
      <div class="edit-bar" v-if="isAdmin"><div class="edit" v-on:click.stop="addNode()">Add new</div></div>
      <ul class="slides">
        <isotope v-if="numSlides > 0" ref="cpt" :options="getOptions()"  @sort="sortOption=arguments[0]" :list="slides" v-images-loaded:on.progress="layout">
          <li v-for="(slide,si) in slides" :key="si" :data-index="si" :data-id="slide.nid" :data-path="slide.path" :class="slide.classNames">
            <v-touch tag="div" class="tap-overlay" v-on:tap="hideShowCaption" :data-index="si"></v-touch>
            <figure class="pictures" :class="'num-images-'+slide.numImages" v-on:click.stop="showFullNode(slide)" v-scroll-to="'body'">
              <template v-for="(img,index) in slide.images">
                <template v-if="img.listed">
                  <template v-if="img.picture">
                    <vue-picture :imgset="img" :sizes="pictureSizes" :className="'active'"></vue-picture>
                  </template>
                  <template v-else>
                    <picture class="original active">
                      <img :src="img.sizes.orig" :alt="img.attributes.title" :width="img.attributes.width" :height="img.attributes.height" />
                    </picture>
                  </template>
                </template>
                <figcaption>
                  <div class="inner">
                    <h4>{{slide.title}}</h4>
                    <hr class="divider" />
                    <p class="category">{{slide.category}}</p>
                  </div>
                </figcaption>
              </template>
            </figure>
            <div class="sort-bar" v-if="isAdmin"><div class="arrow up" v-on:click.stop="sortSlides(si,'up')">&uarr;</div><div class="weight">{{(si+1)}}</div><div class="arrow down" v-on:click.stop="sortSlides(si,'down')">&darr;</div></div>
          </li>
        </isotope>
      </ul>
    </div>
    <div class="sort-save" v-if="isAdmin && viewMode == 'show-listing'">
      <p class="message" v-if="sortMessage.length > 3">{{sortMessage}}</p>
      <div class="shuffle" v-on:click="toggleShuffle()" :title="shuffleHint">Shuffle {{shuffleMode}}</div>
      <div class="button" v-on:click="saveSort()">Save sort</div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import isotope from 'vueisotope'
import imagesLoaded from 'vue-images-loaded'

import VuePicture from './VuePicture.vue'
import VueEmbedplayer from './VueEmbedplayer.vue'
import VueVideoplayer from './VueVideoplayer.vue'
import VueAudioplayer from './VueAudioplayer.vue'

export default {
  name: 'work',
  directives: {
    imagesLoaded
  },
  components: {
    isotope,
    VuePicture,
    VueEmbedplayer,
    VueVideoplayer,
    VueAudioplayer
  },
  props: {
    isAdmin: false,
    winWidth: 0,
    winHeight: 0,
    prevY: 0,
    prevStopY: 0
  },
  data: function () {
    return {
      title: 'Projects',
      viewMode: 'show-listing',
      loading: false,
      slides: [],
      numSlides: 0,
      loadedMore: false,
      defaultSize: 'max_1300x1300',
      hasFullImage: false,
      showFull: false,
      prevListY: 0,
      mediaPlaying: '',
      fillPicCalled: false,
      fullNode: {
        nid: 0,
        title: '',
        body: '',
        images: [],
        sections: []
      },
      imgsLoaded: false,
      fullCaption: '',
      showFullCaption: false,
      sortMessage: '',
      shuffleMode: 'off',
      shuffleHint: 'toggle sort mode',
      pictureSizes: {
        'max_650x650': '(min-width:1301px)',
        'max_325x325': '(max-width:1300px)'
      },
      fullSizes: {
        'max_2600x2600': '(min-width:1301px)',
        'max_1300x1300': '(min-width:651px) and (max-width:1300px)',
        'max_650x650': '(min-width:326px) and (max-width:650px)',
        'max_325x325': '(max-width:325px)'
      }
    }
  },
  beforeRouteEnter: function (to, from, next) {
    next(function (vm) {
      vm.initPage()
    })
  },
  created: function () {
    window.addEventListener('hashchange', this.handlePop)
    var comp = this
    this.$parent.$on('reload-projects', function () {
      comp.loadSlides(false, true)
    })
    this.shuffleMode = this.$parent.shuffle? 'on' : 'off'
  },
  watch: {
    prevY: function () {
      if (this.prevY > this.prevStopY) {
        if (this.$parent.scrollY > this.winHeight / 32) {
          this.loadMoreSlides()
        }
      }
    }
  },
  methods: {
    initPage: function () {
      if (this.loading !== true) {
        this.loadSlides(false)
        if (this.$parent.infoLoaded) {
          this.loadSlides(false)
        } else {
          var comp = this
          setInterval(function () {
            if (comp.$parent.infoLoaded && comp.loading !== true) {
              comp.loadSlides(false)
            }
          }, 200)
        }
      }
    },
    loadDetail: function () {
      var path = this.$parent.path()
      if (path) {
        if (path.length > 2) {
          this.loading = true
          path = path.replace('#', '')
          if (path !== '/projects') {
            this.fillPicCalled = false
            this.loadDetailNode(path)
          }
        }
      }
    },
    loadDetailNode: function (path) {
      var index = _.findIndex(this.slides, function (slide) {
        return slide.path === path
      })
      var comp = this
      if (index >= 0) {
        this.showFullNode(this.slides[index])
        setTimeout(function () {
          comp.$parent.pageHeight = comp.$parent.calcPageHeight()
        }, 400)
      } else {
        var moreSlides = this.$ls.get('projects-full-more', null)
        if (moreSlides instanceof Array) {
          index = _.findIndex(moreSlides, function (slide) {
            return slide.path === path
          })
          if (index >= 0) {
            comp.showFullNode(moreSlides[index], true)
          }
          this.loadSlides(true)
        }
      }
      setTimeout(function () {
        comp.loading = false
      }, 200)
    },
    loadSlides: function (more, remote) {
      var comp = this
      var refName = 'projects-full'
      if (more === true) {
        refName += '-more'
      } else {
        more = false
      }
      this.loading = true
      var slides = this.$ls.get(refName, null)
      if (this.$parent.init === true && more !== true) {
        var moreSlides = this.$ls.get(refName + '-more', null)
        if (moreSlides instanceof Array) {
          if (moreSlides.length > 0) {
            slides = _.union(slides, moreSlides)
            this.loadedMore = true
            more = false
          }
        }
      }
      if (slides instanceof Array) {
        if (more) {
          this.cascadeSlides(slides)
        } else {
          this.slides = slides
          if (this.$parent.shuffle) {
            this.slides = _.shuffle(this.slides);
          }
        }
        this.numSlides = this.slides.length
        if (more !== true) {
          setTimeout(function () {
            comp.imgsLoaded = true
            comp.loadDetail()
            this.loading = false
            if (more === false && this.winWidth >= 640) {
              this.$parent.scrollTo(0)
            }
            setTimeout(comp.loadMoreSlides, 2000)
          }, 1000)
        }
        setTimeout(this.layout, 1750)
      } else {
        this.$parent.addContainerClass('init-load')
        var matched = false
        if ($preload.top_projects && more !== true && remote !== true) {
          if ($preload.top_projects.valid) {
            comp.injectSlides($preload.top_projects.items, false)
            matched = true
          }
        }
        if (!matched) {
          this.$http.get(this.$parent.backend + 'jsonstyles/' + refName).then(function (response) {
            if (response.data.items instanceof Array) {
              comp.injectSlides(response.data.items, more)
            }
          }, function (response) {})
        }
      }
    },
    injectSlides: function (data, more) {
      var comp = this
      this.addSlides(data, more)
      setTimeout(this.loadMoreSlides, 2000)
      if (this.$parent.shuffle && more === false) {
        this.slides = _.shuffle(this.slides);
      }

      setTimeout(function () {
        comp.$parent.removeContainerClass('init-load')
      }, 500)
      if (more === false && comp.winWidth >= 640) {
        this.$parent.scrollTo(0)
      }
    },
    loadMoreSlides: function () {
      if (this.loadedMore === false) {
        this.loadSlides(true)
        this.loadedMore = true
      }
    },
    addSlides: function (data, more) {
      this.numSlides = data.length
      var slides = []
      for (var i = 0; i < this.numSlides; i++) {
        if (typeof data[i] === 'object') {
          var slide = data[i]
          slide.classNames = ['slide']
          slide.numImages = 0
          if (slide.images instanceof Array) {
            this.processImages(slide)
          }
          slides.push(slide)
        }
      }
      if (more === true) {
        this.cascadeSlides(slides)
        this.$ls.set('projects-full-more', slides, (24 * 60 * 60 * 1000))
      } else {
        this.slides = slides
        this.$ls.set('projects-full', this.slides, (24 * 60 * 60 * 1000))
        more = false
      }

      this.numSlides = this.slides.length
      var comp = this
      setTimeout(function () {
        comp.imgsLoaded = true
        comp.loadDetail()
        this.loading = false
      }, 1000)
      setTimeout(this.layout, 1750)
      this.$parent.pageHeight = comp.$parent.calcPageHeight()
    },
    cascadeSlides: function (slides) {
      var num = slides.length
      if (num > 0) {
        var comp = this
        for (var i = 0; i < num; i++) {
          this.slides.push(slides[i])
          setTimeout(comp.layoutQuick, (i * 100))
        }
      }
    },
    processImages: function (slide) {
      slide.numImages = slide.images.length
      slide.hasImages = slide.numImages > 0
      var hideIndex = -1
      if (!slide.listing_index) {
        slide.listing_index = 0;
      }
      if (slide.listing_index < slide.numImages) {
        slide.listing_index = parseInt(slide.listing_index)
      }
      if (slide.hide_from_detail) {
        if (slide.hide_from_detail === true) {
          hideIndex = slide.listing_index;
          if (slide.numImages > 1) {
            slide.numImages -= 1
          }
        }
      }
      for (var j = 0; j < slide.images.length; j++) {
        var cln = 'index-0 active' + j
        var attrs = slide.images[j].attributes
        if (j === 0) {
          cln += ' active'
        }
        attrs.className = cln
        if (slide.images[j].sizes) {
          var sizes = slide.images[j].sizes
          if (typeof sizes === 'object') {
            slide.images[j] = {
              sizes: sizes,
              attributes: attrs,
              type: slide.images[j].type,
              picture: slide.images[j].picture,
              show: j !== hideIndex,
              listed: slide.listing_index === j
            }
          }
        }
      }
    },
    matchEdited: function (slide) {
      var edited = this.$ls.get('editednodes')
      if (edited) {
        if (edited.total) {
          if (edited.total > 0) {
            return _.findIndex(edited.nodes, function (n) {
              return parseInt(n.nid) === parseInt(slide.nid)
            })
          }
        }
      }
      return -1
    },
    fetchEdited: function (slide, index) {
      var comp = this
      this.$http.get(this.$parent.backend + 'jsonstyles/project-full/' + slide.nid).then(function (response) {
        if (response.data instanceof Object) {
          comp.fullNode = response.data
          var index = _.findIndex(comp.slides, function (n) {
            return n.nid === comp.fullNode.nid
          })
          if (index >= 0) {
            comp.slides[index] = response.data
          }
          comp.updateFullNode()
        }
      }, function (response) {})
    },
    updateFullNode: function () {
      var slide = this.fullNode
      this.fullNode.numImages = 0
      this.fullNode.hasImages = false
      this.viewMode = 'show-detail'
      if (slide.images) {
        if (this.fullNode.images instanceof Array) {
          this.fullNode.numImages = slide.images.length
          this.fullNode.hasImages = this.fullNode.numImages > 0
          if (this.fullNode.hasImages) {
            this.processImages(this.fullNode)
          }
        }
      }
      if (slide.sections) {
        this.fullNode.numSections = 0
        this.fullNode.hasSections = false
        this.addImageClasses(this.fullNode)
        if (slide.sections instanceof Array) {
          this.fullNode.numSections = slide.sections.length
          this.fullNode.hasSections = this.fullNode.numSections > 0
          var hasImages = false
          if (this.fullNode.hasSections) {
            for (var i = 0; i < this.fullNode.numSections; i++) {
              if (this.fullNode.sections[i].images) {
                hasImages = this.fullNode.sections[i].images.length > 0
                if (this.fullNode.sections[i].hasImages) {
                  this.processImages(this.fullNode.sections[i])
                  this.addImageClasses(this.fullNode.sections[i])
                }
              } else {
                hasImages = false
              }
              this.fullNode.sections[i].hasImages = hasImages
            }
          }
        }
      }
    },
    addImageClasses: function (slide) {
      slide.imageClasses = 'num-images-' + slide.numImages
      if (slide.numImages > 1) {
        slide.imageClasses += ' has-many'
      }
      if (!slide.image_layout) {
        slide.image_layout = 'flex-row'
      }
      if (slide.numImages > 1 && slide.image_layout !== 'max-1') {
        slide.imageClasses += ' rows'
      }
      slide.imageClasses += ' ' + slide.image_layout
    },
    showFullNode: function (slide, stopPop) {
      var index = this.matchEdited(slide)
      this.prevListY = this.$parent.scrollY
      this.processTapClasses(-1)
      if (index < 0) {
        this.addImageClasses(slide)
        this.fullNode = slide
        this.updateFullNode()
      } else {
        this.fetchEdited(slide)
      }
      if (stopPop !== true) {
        window.location = '#' + slide.path
      }
    },
    hideFull: function (stopPop) {
      if (this.viewMode !== 'show-listing') {
        this.viewMode = 'show-listing'
        if (stopPop !== true) {
          window.location = '#/projects'
        }
        var comp = this
        this.loading = true
        setTimeout(function () {
          comp.$parent.scrollTo(comp.prevListY, 2000)
          comp.loading = false
        }, 100)
        setTimeout(function () {
          comp.$parent.pageHeight = comp.$parent.calcPageHeight()
          comp.layout()
        }, 250)
      }
    },
    hideShowCaption: function (e) {
      var index = e.target.getAttribute('data-index')
      if (!index) {
        index = 0
      } else {
        index = parseInt(index)
      }
      if (index < this.slides.length) {
        this.processTapClasses(index)
      }
    },
    processTapClasses: function (index) {
      if (!index && typeof index !== 'number') {
        index = -1
      }
      var sm
      for (var i = 0; i < this.slides.length; i++) {
        var sl = this.slides[i]
        if (sl.classNames) {
          if (sl.classNames instanceof Array) {
            var ti = sl.classNames.indexOf('tapped')
            if (ti < 0 && i === index) {
              sl.classNames.push('tapped')
              sm = sl
            } else if (ti >= 0) {
              sl.classNames = ['slide']
            }
          }
        }
      }
      if (sm) {
        setTimeout(function () {
          sm.classNames.push('tapped-over')
        }, 250)
      }
    },
    getOptions: function () {
      return {
        itemSelector: '.slide',
        initLayout: false,
        gutter: 0
      }
    },
    layoutQuick: function () {
      this.layout(1)
    },
    layout: function (ts) {
      var comp = this
      if (!ts) {
        ts = 250
      }
      setTimeout(function () {
        if (comp.$refs.cpt) {
          comp.$refs.cpt.layout('masonry')
        }
      }, ts)
    },
    toggleCaption: function () {
      this.showFullCaption = !this.showFullCaption
    },
    handlePop: function (e) {
      if (e.oldURl !== e.newURL) {
        var path = window.location.hash
        if (path.length > 0) {
          path = path.replace(/^#/, '')
          if (path === '/projects' || path === '#/projects' || path.length < 3) {
            this.hideFull(true)
          } else if (path.indexOf('/projects') === 0) {
            if (this.loading !== true) {
              this.loadDetailNode(path)
            }
          }
        }
      }
    },
    editNode: function (id) {
      this.$parent.adminUrl = '/node/' + id + '/edit'
    },
    addNode: function() {
      this.$parent.adminUrl = '/node/add/project'
    },
    sortSlides: function(index, dir) {
      var ni = 0
      if (dir === 'down') {
        ni = index + 1
      } else {
        ni = index - 1
      }
      if (ni < 0) {
        ni = this.slides.length - 1
      } else if (ni >= this.slides.length) {
        ni = 0
      }
      var arr = this.slides.splice(index, 1)
      this.slides.splice(ni, 0,arr[0])
      var comp = this
      setTimeout(function() {
        comp.$refs.cpt.layout('masonry')
      }, 250)
    },
    saveSort: function() {
      var nids = _.map(this.slides, function (sl) { return sl.nid })
      if (nids.length > 1) {
        var url = this.$parent.backend + 'admin/content/sort-projects?ids=' + nids.join(',')
        var shVal = this.$parent.shuffle? '1' : '0'
        url += '&shuffle=' + shVal
        var comp = this
        this.$http.get(url).then(function (response) {
          if (response.data) {
            if (response.data.msg) {
              comp.sortMessage = response.data.msg
              comp.$parent.clearLocalStorage()
              setTimeout(function () {
                comp.sortMessage = ''
              }, 5000)
            }
          }
        }, function (response) {})
      }
    },
    toggleShuffle: function () {
      this.$parent.shuffle = !this.$parent.shuffle
      this.shuffleMode = this.$parent.shuffle? 'on' : 'off'
      this.shuffleHint = this.$parent.shuffle? 'Disable' : 'enable'
      this.shuffleHint += ' shuffling'
      if (this.$parent.shuffle) {
        this.slides = _.shuffle(this.slides);
      } else {
        this.slides = _.sortBy(this.slides, [function(sl) { return sl.weight; }]);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Work.vue?59bdeba2